import React from 'react';

import SharedTestimonials, { TestimonialsProps } from './SharedTestimonials';

const TeladocTestimonials: React.FC<TestimonialsProps> = ({ setShowTestimonials }) => {
  const testimonials = [
    {
      background: '#bac0fe',
      textColor: '#211c78',
      boldText: '“I like the feedback on the monitor. It lets me know if I’m in range or not.”',
      lightText: '—A real-life Teladoc user',
    },
    {
      background: '#8f3bab',
      textColor: '#ffffff',
      boldText:
        '“The ease and simplicity of [Teladoc takes] so much off my plate. They know where I’m at with my supplies, and the meter reminds me to order. The fact that it doesn’t cost anything is great.”',
      lightText: '—Another actual Teladoc user',
    },
  ];

  return (
    <SharedTestimonials
      brand="teladoc"
      testimonials={testimonials}
      setShowTestimonials={setShowTestimonials}
      backgroundColor="#e4f6fc"
    />
  );
};

export default TeladocTestimonials;
